import React, { useState, createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { is } from 'Common/Utils'
const SessionContext = createContext({});

export const useSession = () => {
	return useContext(SessionContext);
};

export const Session = ({ children, value = {} }) => {
	const [session, setSession] = useState(value);
	const provide = useMemo(
		() => ({
			deleteSession(name) {
				setSession((prev) => {
					delete prev[name];
					return { ...prev };
				});
			},
			setSession(name, value) {
				setSession((prev) => ({ ...prev, [name]:  is.fnc(value) ? value(prev[name]) : value }));
			},
			getSession(name) {
				return session[name];
			},
			flushSession() {
				setSession(value);
			},
		}),
		[session, value]
	);
	return (
		<SessionContext.Provider value={provide}>
			{children}
		</SessionContext.Provider>
	);
};

Session.propTypes = {
	value: PropTypes.object,
	children: PropTypes.oneOfType([
		PropTypes.element,
		PropTypes.arrayOf(PropTypes.element),
	]),
};
